import { Icon } from "@blueprintjs/core";
import { type IconName } from "@blueprintjs/icons";
import { useTriviaContext } from "../context-trivia";
import type { TriviaHelp } from "../trivia-types";

type TriviaButtonHelpProps = {
  help: TriviaHelp;
  icon: IconName;
  text: string;
  disabled: boolean;
  onHandleMouse: (help: TriviaHelp) => void;
};

export function TriviaButtonHelp({
  help,
  icon,
  text,
  disabled,
  onHandleMouse,
}: TriviaButtonHelpProps) {
  const { config } = useTriviaContext();

  return (
    <button
      type="button"
      className="flex flex-col items-center gap-1 font-bold"
      disabled={disabled}
      style={{
        color: config.theme.buttonText,
        opacity: disabled ? 0.5 : 1,
        fontSize: "var(--trivia-text-meta)",
        touchAction: "manipulation",
      }}
      onPointerDown={() => {
        if (!disabled) {
          onHandleMouse(help);
        }
      }}
    >
      <Icon icon={icon} size={28} />
      <div>{text}</div>
    </button>
  );
}
